export const HistoryIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M11.5 21C9.07222 21 6.95671 20.1951 5.15347 18.5854C3.35023 16.9757 2.31667 14.9657 2.05278 12.5556H4.21667C4.46296 14.3852 5.27662 15.8981 6.65764 17.0944C8.03866 18.2907 9.65278 18.8889 11.5 18.8889C13.5583 18.8889 15.3044 18.172 16.7382 16.7382C18.172 15.3044 18.8889 13.5583 18.8889 11.5C18.8889 9.44167 18.172 7.6956 16.7382 6.26181C15.3044 4.82801 13.5583 4.11111 11.5 4.11111C10.2861 4.11111 9.15139 4.39259 8.09583 4.95556C7.04028 5.51852 6.15185 6.29259 5.43056 7.27778H8.33333V9.38889H2V3.05556H4.11111V5.53611C5.00833 4.41019 6.10347 3.53935 7.39653 2.92361C8.68958 2.30787 10.0574 2 11.5 2C12.8194 2 14.0553 2.25069 15.2076 2.75208C16.36 3.25347 17.3627 3.93079 18.216 4.78403C19.0692 5.63727 19.7465 6.64005 20.2479 7.79236C20.7493 8.94468 21 10.1806 21 11.5C21 12.8194 20.7493 14.0553 20.2479 15.2076C19.7465 16.36 19.0692 17.3627 18.216 18.216C17.3627 19.0692 16.36 19.7465 15.2076 20.2479C14.0553 20.7493 12.8194 21 11.5 21ZM14.4556 15.9333L10.4444 11.9222V6.22222H12.5556V11.0778L15.9333 14.4556L14.4556 15.9333Z"
        fill="var(--swapper-text-color)"
      />
    </svg>
  );
};
